module.exports = __webpack_public_path__ + "img/empresas.b461cda3.svg";